import React from "react";

import { Checkbox } from "../../checkbox";
import { Props } from "./types";
import styles from "./styles.scss";

function OrganizationalUnit({
  organizationalUnit,
  depth,
  isSelected,
  toggle,
}: Props) {
  return (
    <div
      className={styles.organizationalUnit}
      style={{ paddingLeft: `${2 * depth}rem` }}
      onClick={toggle}
    >
      <Checkbox isChecked={isSelected} />
      <p className={styles.name}>{organizationalUnit.name}</p>
    </div>
  );
}

export { OrganizationalUnit };
